/**
 * Gate canônico de "ambiente de teste" do admin-interface.
 *
 * ⚠️ EXCLUSIVO DE AMBIENTE DE TESTE: qualquer recurso/atalho/botão que só pode
 * existir fora de produção (ex.: bypass de feature flag, ferramentas de dev,
 * dados mock) DEVE ser gateado por estes helpers — nunca por checagens ad-hoc
 * de `window.location.hostname`.
 *
 * Use o hook `useIsTestEnvironment()` (`@/hooks/use-is-test-environment`) em
 * componentes React, ou `isCurrentBrowserTestEnvironment()` em código
 * imperativo. Para adicionar um novo host de teste, edite apenas
 * `TEST_ENVIRONMENT_HOSTS` abaixo.
 *
 * Hosts considerados ambiente de teste: localhost (e `*.localhost`), loopback
 * IPv4/IPv6 e a homologação (`hmg-manager.gamefik.com`). Produção nunca casa.
 */
const TEST_ENVIRONMENT_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "::1",
  "[::1]",
  "hmg-manager.gamefik.com",
]);

export function normalizeHostname(hostname?: string | null) {
  return hostname?.trim().toLowerCase() ?? "";
}

export function isTestEnvironmentHost(hostname?: string | null) {
  const normalizedHostname = normalizeHostname(hostname);

  if (!normalizedHostname) {
    return false;
  }

  return TEST_ENVIRONMENT_HOSTS.has(normalizedHostname) || normalizedHostname.endsWith(".localhost");
}

export function getCurrentBrowserHostname() {
  if (typeof window === "undefined") {
    return null;
  }

  return window.location.hostname;
}

export function isCurrentBrowserTestEnvironment() {
  return isTestEnvironmentHost(getCurrentBrowserHostname());
}
